module.exports = __webpack_public_path__ + "img/default-banner.d696b258.jpg";